import { type yup } from '@framework/validation/initYup.ts';
import { evaluateExpression } from '../../../../expressions/evaluate/evaluateExpression.ts';
import { type IConditionGroupExpression } from '../../../../expressions/repository/condition-group/IConditionGroupExpression.ts';
import { type IParentWidgetScope } from '../../../IWidgetType.ts';
import { setComputeTransform } from '../setComputedTransform.ts';

export function setComputedBooleanTransform(
  widget: { expression: IConditionGroupExpression },
  parentScope: IParentWidgetScope,
  schema: yup.AnySchema,
) {
  return setComputeTransform(
    widget.expression,
    parentScope,
    schema,
    (expression, variables) => {
      return evaluateExpression(expression, { variables });
    },
  );
}
